import React from "react";
import styled from "styled-components";
import { Collapse as AntCollapse } from "antd";
import { CaretRightOutlined } from "@ant-design/icons";

const { Panel: AntPanel } = AntCollapse;

export const Collapse = styled(AntCollapse).attrs(() => ({
  bordered: false,
  expandIcon: ({ isActive }) => (
    <CaretRightOutlined rotate={isActive ? 90 : 0} />
  ),
}))`
  background-color: transparent;

  .ant-collapse-item {
    border-bottom: 2px solid #1070b6;
  }
`;

export const Panel = styled(AntPanel)`
  .ant-collapse-header {
    color: #282828 !important;
    letter-spacing: 0.4px;
    font-size: 16px;

    :hover {
      color: #1070b6 !important;
    }
  }

  .ant-collapse-content {
    color: #282828;
    letter-spacing: 0.4px;
  }

  .ant-collapse-content-box > p {
    white-space: pre-line;
  }
`;

// Need a parent with fixed height to make infinite scrolling works
export const FixedHeightContainer = styled.div`
  height: 100vh;
  overflow: auto;
`;
